<template>
    <div class="copy-start-dates" :style="{ '--visible-rows': visibleRows }">
        <div
            v-for="(startDate, index) in modelValue"
            :key="index"
            class="copy-start-dates__row"
            data-id-e2e="copyStartDateRow"
        >
            <span class="copy-start-dates__label">
                {{ toSentenceCase($t(label)) }}
            </span>
            <vuex-date-picker
                class="copy-start-dates__picker"
                :getter="() => startDate"
                :setter="value => updateRow(index, value)"
                :min-date="minDate"
                :max-date="maxDate"
            />
            <div class="copy-start-dates__actions">
                <span class="copy-start-dates__action-slot">
                    <icon-button
                        v-if="allowMultiple && index === modelValue.length - 1"
                        class="copy-start-dates__action-button"
                        icon="mdi-plus"
                        material-icon-class="text-primary copy-start-dates__plus-icon"
                        data-id-e2e="addCopyStartDateBtn"
                        :title="toSentenceCase($t('actions.add'))"
                        :disabled="modelValue.length >= max"
                        @click="addRow"
                    />
                </span>
                <span class="copy-start-dates__action-slot">
                    <icon-button
                        v-if="modelValue.length > 1"
                        class="copy-start-dates__action-button"
                        icon="custom:trash"
                        data-id-e2e="removeCopyStartDateBtn"
                        :title="toSentenceCase($t('actions.remove'))"
                        @click="removeRow(index)"
                    />
                </span>
            </div>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    modelValue: {
        type: Array,
        required: true,
    },
    label: {
        type: String,
        required: true,
    },
    minDate: {
        type: String,
        default: null,
    },
    maxDate: {
        type: String,
        default: null,
    },
    max: {
        type: Number,
        required: true,
    },
    allowMultiple: {
        type: Boolean,
        default: false,
    },
    visibleRows: {
        type: Number,
        default: 10,
    },
});

const emit = defineEmits(['update:modelValue']);

const updateRow = (index, value) => {
    emit(
        'update:modelValue',
        props.modelValue.map((startDate, rowIndex) => (rowIndex === index ? value : startDate))
    );
};

const addRow = () => {
    const startDates = props.modelValue;
    if (startDates.length >= props.max) return;

    emit('update:modelValue', [...startDates, startDates[startDates.length - 1]]);
};

const removeRow = index => {
    emit('update:modelValue', props.modelValue.filter((startDate, rowIndex) => rowIndex !== index));
};
</script>

<style lang="scss" scoped>
.copy-start-dates {
    --row-height: 4.4rem;

    max-height: calc(var(--visible-rows) * var(--row-height));
    overflow-y: auto;

    &__row {
        display: grid;
        grid-template-columns: minmax(0, 1fr) minmax(0, 13rem) 6rem;
        align-items: center;
        column-gap: 0.5rem;
        height: var(--row-height);
        padding: 0 2rem;
    }

    &__label {
        min-width: 0;
        text-align: right;
        font-weight: bold;
    }

    &__picker {
        min-width: 0;
        width: 100%;
    }

    &__actions {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 0.25rem;
        padding-left: 0.5rem;
    }

    &__action-slot {
        display: flex;
        flex: 0 0 2.6rem;
        align-items: center;
        justify-content: center;
        width: 2.6rem;
        height: 2.6rem;
    }

    :deep(.copy-start-dates__action-button) {
        flex: 0 0 2.6rem;
        width: 2.6rem;
        height: 2.6rem;
        padding: 0;
        justify-content: center;
    }

    :deep(.copy-start-dates__plus-icon) {
        width: 2.6rem;
        height: 2.6rem;
        font-size: 2.6rem !important;
    }
}
</style>
